/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Student_NameInputs */

const en_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const de_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const fr_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étudiant`)
};

const es_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudiante`)
};

const it_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studente`)
};

const nl_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const pl_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

const fi_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opiskelija`)
};

const da_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studerende`)
};

const sv_pricing_plan_student_name = /** @type {(inputs: Pricing_Plan_Student_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student`)
};

/**
* | output |
* | --- |
* | "Student" |
*
* @param {Pricing_Plan_Student_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_student_name = /** @type {((inputs?: Pricing_Plan_Student_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Student_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_student_name(inputs)
	if (locale === "fr") return fr_pricing_plan_student_name(inputs)
	if (locale === "es") return es_pricing_plan_student_name(inputs)
	if (locale === "it") return it_pricing_plan_student_name(inputs)
	if (locale === "nl") return nl_pricing_plan_student_name(inputs)
	if (locale === "pl") return pl_pricing_plan_student_name(inputs)
	if (locale === "fi") return fi_pricing_plan_student_name(inputs)
	if (locale === "da") return da_pricing_plan_student_name(inputs)
	if (locale === "sv") return sv_pricing_plan_student_name(inputs)
	return en_pricing_plan_student_name(inputs)
});